import { render, staticRenderFns } from "./index.vue?vue&type=template&id=72522466&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72522466')) {
      api.createRecord('72522466', component.options)
    } else {
      api.reload('72522466', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=72522466&", function () {
      api.rerender('72522466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/pages/promotions/index.vue"
export default component.exports